export default __webpack_public_path__ + "static/media/ficon-4.7bc13724.svg";